// @flow
import { pipe, map } from 'ramda';

import PlanogramItem, { type RawDataItem } from './planogram-item';
import { createPlanogramItem } from './create-planogram-item';
import { createGrid } from './create-grid';
import PlanogramDataExt from './planogram-data-ext';


export function createPlanogramDataExt(items?: Array<RawDataItem> = []): PlanogramDataExt<PlanogramItem> {
  const grid = pipe(
    map(createPlanogramItem),
    createGrid,
  )(items);

  return new PlanogramDataExt<PlanogramItem>(grid);
}
